// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fw","advertDetailHeaderLocation__value":"c-m_fx"};